
import sithMesMstShiftCalendar from "@/views/sithMes/mst/SithMesMstShiftCalendar.vue";
import previewPdf from "@/components/Pdf/PreviewPdf";
import sithMesMstProjectPlanTemplateTreeTableList from "@/views/sithMes/mst/SithMesMstProjectPlanTemplateTreeTableList";
import sithMesSapAddressConfig from "@/views/sithMes/mst/SithMesSapAddressConfig.vue";

const metaObject = { requiresAuth: true, roles: ['mmf'] };

export default [
    {
        path: "/sithMes/mst/sithMesMstShiftCalendar",
        name: "sithMesMstShiftCalendar",
        component: sithMesMstShiftCalendar,
        meta: metaObject
    },
    {
        path: "/sithMes/mst/previewPdf",
        name: "previewPdf",
        component: previewPdf
    },
    {
        path: "/sithMes/mst/sithMesMstProjectPlanTemplateTreeTableList",
        name: "sithMesMstProjectPlanTemplateTreeTableList",
        component: sithMesMstProjectPlanTemplateTreeTableList,
        props: (route) => ({ prop_inline: route.query.inline }),
        meta: metaObject
    },
    {
        path: "/sithMes/mst/sapAddressConfig",
        name: "sithMesSapAddressConfig",
        component: sithMesSapAddressConfig,
        meta: metaObject
    }
]